export enum TariffDimensionTypeEnum {
  'ENERGY' = 'ENERGY',
  'FLAT' = 'FLAT',
  'TIME' = 'TIME',
}
